
import { useQuery } from "react-query";
import { getDoctors } from "../Components/Api/api"

const useGetDoctorsSemanticUI = () => {

    const GetAllDoctors = useQuery("GetAllDoctors", () =>
        getDoctors()
    );

    let Doctors_list = "";

    if (GetAllDoctors?.data) {
        Doctors_list = GetAllDoctors?.data.map((item) => (
            { key: item.idAuth, text: item.user_name, value: item.idAuth }
        ))
    }


    return (
        { Doctors_list }
    )
}

export default useGetDoctorsSemanticUI